<template>
    <div>
        <h4>{{title}}</h4>
        <table class="table-sm table-striped table-bordered">
            <!-- SonarQube staat er op dat een <caption> wordt toegevoegd -->
            <caption v-if="false">Options</caption>
            <thead>
                <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0">{{$t('labelDomainKey')}}</th>
                    <th scope="col" class="border-0">{{$t('labelDomainValue')}}</th>
                    <th scope="col" class="border-0"></th>
                </tr>
            </thead>
            <v-draggable tag="tbody" handle=".handle">
                <tr v-for="(option, index) in localOptions" :key="`option${index}`">
                    <td>
                        <div class="option-icon">
                            <em class="fa fa-arrows-alt handle"></em>
                        </div>
                    </td>
                    <td>
                        <x-input type="text"
                                 :required="true"
                                 maxlength="100"
                                 v-model="option.text"
                                 class="option-input" />
                    </td>
                    <td>
                        <x-input type="text"
                                 :required="true"
                                 maxlength="100"
                                 v-model="option.value"
                                 class="option-input" />
                    </td>
                    <td>
                        <a :title="$t('printComponent.dashboard.deleteOptionsChoice')"
                           class="option-icon option-delete"
                           @click="$_onRemoveChoice(index)">
                            <em class="fas fa-times"></em>
                        </a>
                    </td>
                </tr>
            </v-draggable>
            <tfoot>
                <tr>
                    <td></td>
                    <td>
                        <x-input type="text"
                                 maxlength="100"
                                 v-model="newoption.text"
                                 class="option-input" />
                    </td>
                    <td>
                        <x-input type="text"
                                 maxlength="100"
                                 v-model="newoption.value"
                                 class="option-input" />
                    </td>
                    <td>
                        <div>
                            <b-button variant="primary"
                                      @click="$_onAddOption"
                                      :disabled="!newoption.text && !newoption.value">{{$t('btnAddLabel')}}</b-button>
                        </div>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
    import xinput from '../../../components/BaseComponents/x-input.vue';
    import draggable from 'vuedraggable';
    export default {
        components: { 'x-input': xinput, 'v-draggable': draggable },
        props: {
            options: { type: Array, required: true },
            title: { type: String, default: 'Opties' },
        },

        data() {
            return {
                newoption: {},
                localOptions: null
            };
        },

        methods: {
            $_onAddOption () {
                this.localOptions.push({ ...this.newoption });
                this.newoption = {};
            },
            $_onRemoveChoice(index) {
                this.localOptions.splice(index, 1);
            }
        },
        watch: {
            options: {
                handler: function (newVal) {
                    this.localOptions = JSON.parse(JSON.stringify(newVal));
                },
                deep: true,
                immediate: true
            },
            localOptions: {
                handler: function (newVal) {
                    if (JSON.stringify(newVal) === JSON.stringify(this.options)) {
                        return;
                    }
                    const locOptions = JSON.parse(JSON.stringify(newVal));
                    this.$emit('update', locOptions);
                },
                deep: true
            }
        }
    };
</script>

<style scoped>
    .option-icon {
        padding: 8px;
        cursor: pointer;
    }

    .option-input {
        padding-right: 15px;
    }

    .option-delete {
        color: red;
        text-decoration: none;
    }
</style>

<style>
    .option-input .form-group {
        margin-bottom: 0;
    }
</style>
